const pageNameKey = "smallBlueprintBannerAutoMatch";

export const smallBlueprintBannerAutoMatchEn = {
  [pageNameKey]: {
    smallOrangeText: "Tomorrow Things Exclusive",
    gradientText: "Blueprints are the easiest way of setting up your clients.",
    autoMatchBlueprintButton: "Auto Match Blueprint",
    myBlueprintLibraryButton: "My Blueprint Library",
    saveBlueprintButton: "Save as Blueprint",
  },
};

export const smallBlueprintBannerAutoMatchPtBr = {
  [pageNameKey]: {
    smallOrangeText: "Exclusivo por Tomorrow Things",
    gradientText:
      "Os blueprints são a maneira mais fácil de configurar seus clientes.",
    autoMatchBlueprintButton: "Modelo de Correspondência Automática",
    myBlueprintLibraryButton: "Minha Biblioteca de Blueprints",
    saveBlueprintButton: "Salvar como modelo",
  },
};

export const smallBlueprintBannerAutoMatchDe = {
  [pageNameKey]: {
    smallOrangeText: "Exklusiv bei TomorrowThings",
    gradientText:
      "Blueprints sind der einfachste Weg, um Ihre Clients einzurichten.",
    autoMatchBlueprintButton: "Blueprint automatisch abgleichen",
    myBlueprintLibraryButton: "Meine Blueprint-Bibliothek",
    saveBlueprintButton: "Als Blueprint speichern",
  },
};

export const smallBlueprintBannerAutoMatchZhHans = {
  [pageNameKey]: {
    smallOrangeText: "Tomorrow Things 独家",
    gradientText: "蓝图是设置客户的最简单方法。",
    autoMatchBlueprintButton: "自动匹配蓝图",
    myBlueprintLibraryButton: "我的蓝图库",
    saveBlueprintButton: "保存为蓝图",
  },
};

export const smallBlueprintBannerAutoMatchIt = {
  [pageNameKey]: {
    smallOrangeText: "Esclusiva Tomorrow Things",
    gradientText:
      "I Blueprint sono il modo più facile per impostare i tuoi client.",
    autoMatchBlueprintButton: "Auto-assegna Blueprint",
    myBlueprintLibraryButton: "Libreria Blueprint",
    saveBlueprintButton: "Salva come Blueprint",
  },
};

export const smallBlueprintBannerAutoMatchEs = {
  [pageNameKey]: {
    smallOrangeText: "Exclusiva de Tomorrow Things",
    gradientText:
      "Los planos son la forma más fácil de configurar a tus clientes.",
    autoMatchBlueprintButton: "Plano de coincidencia automática",
    myBlueprintLibraryButton: "Mi biblioteca de planos",
    saveBlueprintButton: "Guardar como plano",
  },
};

export const smallBlueprintBannerAutoMatchNl = {
  [pageNameKey]: {
    autoMatchBlueprintButton: "Blueprint automatisch matchen",
    gradientText:
      "Blueprints zijn de eenvoudigste manier om uw clients te configureren.",
    myBlueprintLibraryButton: "Mijn blueprint-bibliotheek",
    saveBlueprintButton: "Opslaan als blueprint",
    smallOrangeText: "Exclusief bij Tomorrow Things",
  },
};

export const smallBlueprintBannerAutoMatchTr = {
  [pageNameKey]: {
    autoMatchBlueprintButton: "Otomatik Eşleştirme Planı",
    gradientText: "Planlar müşterilerinizi ayarlamanın en kolay yoludur.",
    myBlueprintLibraryButton: "Blueprint Kitaplığım",
    saveBlueprintButton: "Plan olarak kaydet",
    smallOrangeText: "Tomorrow Things'e özel",
  },
};
